module.exports = __webpack_public_path__ + "img/large-waymap.c8033f27.jpg";